import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

const ButtonWrapper = styled.div`
  margin-top: ${tokens.spacing[600]};
`;

export default ButtonWrapper;
